module.exports = __webpack_public_path__ + "img/DE02008.d43e99b7.png";